import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import SEO from '../components/SEO'
import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './galeri.css'

const Galeri = () => {
  const [activeFilter, setActiveFilter] = useState('ALL')

  const galleryItems = [
    {
      title: 'Milimetrik TPU PPF Montaj Süreci',
      category: 'PPF',
      spanClass: 'col-span-8',
      imgSrc: 'https://images.pexels.com/photos/36021355/pexels-photo-36021355.jpeg?auto=compress&cs=tinysrgb&w=1500',
      imgAlt: 'Stüdyoda spor araç gövde paneline şeffaf TPU boya koruma filmi montajı',
    },
    {
      title: 'Kusursuz Boya Yüzeyi ve Derinlik',
      category: 'DETAILING',
      spanClass: 'col-span-4',
      imgSrc: 'https://images.pexels.com/photos/30837753/pexels-photo-30837753.jpeg?auto=compress&cs=tinysrgb&w=1500',
      imgAlt: 'Işık altında boya yüzeyinin pürüzsüz finisajı ve yüzey detayları',
    },
    {
      title: 'Dökme Folyo Renk Değişimi Detayları',
      category: 'KAPLAMA',
      spanClass: 'col-span-6',
      imgSrc: 'https://images.pexels.com/photos/10162529/pexels-photo-10162529.jpeg?auto=compress&cs=tinysrgb&w=1500',
      imgAlt: 'Özel renk tonunda dökme cast folyo araç kaplama çalışması',
    },
    {
      title: 'Seramik Kaplama Sonrası Ayna Yansıması',
      category: 'DETAILING',
      spanClass: 'col-span-6',
      imgSrc: 'https://images.pexels.com/photos/14231701/pexels-photo-14231701.jpeg?auto=compress&cs=tinysrgb&w=1500',
      imgAlt: 'Polisaj ve seramik kaplama tamamlanan aracın ayna parlaklığı',
    },
    {
      title: 'İç Mekan Deri Döşeme ve Kokpit Arındırma',
      category: 'DETAILING',
      spanClass: 'col-span-4',
      imgSrc: 'https://images.pexels.com/photos/6873188/pexels-photo-6873188.jpeg?auto=compress&cs=tinysrgb&w=1500',
      imgAlt: 'Detaylı temizlik ve bakım sonrası araç iç mekanı',
    },
    {
      title: 'Conrad Beşiktaş Stüdyo Uygulama Alanı',
      category: 'STUDIO',
      spanClass: 'col-span-8',
      imgSrc: 'https://images.pexels.com/photos/6969026/pexels-photo-6969026.jpeg?auto=compress&cs=tinysrgb&w=1500',
      imgAlt: 'Ateş Auto Detailing Beşiktaş kapalı stüdyo uygulama ortamı',
    },
  ]

  const filteredItems =
    activeFilter === 'ALL'
      ? galleryItems
      : galleryItems.filter((item) => item.category === activeFilter)

  return (
    <div className="gallery-container teleport-dashboard-layout">
      <SEO
        title="Stüdyo Galerisi & Uygulama Detayları | ATEŞ AUTO DETAILING"
        description="ATEŞ Auto Detailing Conrad Istanbul Bosphorus stüdyomuzdan yüzey detayları, şeffaf PPF kaplama, renk değişimi ve oto detailing görsel arşivi."
        canonicalPath="/galeri"
      />

      <aside className="gallery-sidebar-wrapper teleport-dashboard-sidebar">
        <Navigation />
      </aside>

      <main id="tq-main" className="gallery-content-wrapper teleport-dashboard-content">
        <section className="gallery-hero">
          <nav aria-label="Breadcrumb" className="gallery-breadcrumb">
            <Link to="/">ANA SAYFA</Link>
            <span className="gallery-breadcrumb-separator">/</span>
            <span aria-current="page">GALERİ</span>
          </nav>

          <h1 className="gallery-headline">Stüdyo Galerisi</h1>

          <p className="gallery-description">
            Beşiktaş Conrad stüdyomuzdan yüzey detayları, uygulama kareleri ve stüdyo ortamımız.
            Her aşamada yüzey detaylarına odaklanan uygulama yaklaşımı ve profesyonel otomotiv estetiği ön plandadır.
          </p>
        </section>

        {/* Filtre Barı */}
        <div className="gallery-filter-bar">
          <button
            type="button"
            className={`gallery-filter-btn ${activeFilter === 'ALL' ? 'active' : ''}`}
            onClick={() => setActiveFilter('ALL')}
          >
            TÜMÜ
          </button>
          <button
            type="button"
            className={`gallery-filter-btn ${activeFilter === 'PPF' ? 'active' : ''}`}
            onClick={() => setActiveFilter('PPF')}
          >
            PPF KORUMA
          </button>
          <button
            type="button"
            className={`gallery-filter-btn ${activeFilter === 'KAPLAMA' ? 'active' : ''}`}
            onClick={() => setActiveFilter('KAPLAMA')}
          >
            ARAÇ KAPLAMA
          </button>
          <button
            type="button"
            className={`gallery-filter-btn ${activeFilter === 'DETAILING' ? 'active' : ''}`}
            onClick={() => setActiveFilter('DETAILING')}
          >
            DETAILING &amp; SERAMİK
          </button>
          <button
            type="button"
            className={`gallery-filter-btn ${activeFilter === 'STUDIO' ? 'active' : ''}`}
            onClick={() => setActiveFilter('STUDIO')}
          >
            STÜDYO
          </button>
        </div>

        <section className="gallery-body">
          <div className="gallery-asymmetric-grid">
            {filteredItems.map((item, idx) => (
              <div key={idx} className={`gallery-item ${item.spanClass}`}>
                <img
                  src={item.imgSrc}
                  alt={item.imgAlt}
                  loading="lazy"
                  decoding="async"
                  className="gallery-img"
                />
                <div className="gallery-item-caption">
                  <span className="gallery-item-category">{item.category}</span>
                  <h3 className="gallery-item-title">{item.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </section>

        <Footer />
      </main>
    </div>
  )
}

export default Galeri
